module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "copyrightpage"
  }, [_c('span', {
    attrs: {
      "id": "calibre_toc_1"
    }
  }, [_vm._v("Copyright ")]), _vm._v("© 2020 by Paula Petry PhD."), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Published by Mango Publishing Group, a division of Mango Media"), _c('span'), _vm._v("Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpage"
  }, [_vm._v("Layout & Design: Ronchon Villaester"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Cover illustration: Roberto"), _c('span'), _vm._v("Nunez")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpage"
  }, [_vm._v("Mango is an active supporter of authors’ rights to free speech and artistic expression in their books. The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our open"), _c('span'), _vm._v("society.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpage"
  }, [_vm._v("Uploading or distributing photos, scans or any content from this book without prior permission is theft of the author’s intellectual property. Please honor the author’s work as you would your own. Thank you in advance for respecting our author’s"), _c('span'), _vm._v("rights.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpage"
  }, [_vm._v("For permission requests, please contact the publisher at:"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Mango Publishing Group"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("2850 S Douglas Road, 2nd Floor"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Coral Gables, FL 33134 USA"), _c('br', {
    staticClass: "calibre3"
  }), _c('a', {
    attrs: {
      "href": "mailto:info@mango.bz"
    }
  }, [_vm._v("info@mango.bz")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpage"
  }, [_vm._v("For special orders, quantity sales, course adoptions and corporate sales, please email the publisher at "), _c('a', {
    attrs: {
      "href": "mailto:sales@mango.bz"
    }
  }, [_vm._v("sales@mango.bz")]), _vm._v(". For trade and wholesale sales, please contact Ingram Publisher Services at "), _c('a', {
    attrs: {
      "href": "mailto:customer.service@ingramcontent.com"
    }
  }, [_vm._v("customer.service@ingramcontent.com")]), _vm._v(" or +1.800.509.4887.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpage"
  }, [_vm._v("A Mother’s Courage to Awaken : Hope and Inspiration from My Daughter’s Journey in the"), _c('span'), _vm._v("Afterlife")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpage"
  }, [_vm._v("Library of Congress Cataloging-in-Publication number: 2020940926"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("ISBN: (print) 978-1-64250-417-0, (ebook) 978-1-64250-418-7"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("BISAC category code SEL010000, SELF-HELP / Death, Grief, Bereavement")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpage"
  }, [_vm._v("Printed in the United States of"), _c('span'), _vm._v("America")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightpage"
  }, [_vm._v("Note: This publication is presented solely for informational, educational, and entertainment purposes. It is not intended to provide health advice and should not be relied upon as such. If expert assistance is required, the services of a professional should be sought. The publisher, the author, and their affiliated entities and individuals do not make any guarantees or other promises as to any results that may be obtained from using the content of this book. To the maximum extent permitted by law, the publisher, the author, and their affiliated entities and individuals disclaim any and all liability in the event any information contained in this book proves to be inaccurate, incomplete, or unreliable or results in any losses or harm. You, the reader, are responsible for your own choices, actions, and results.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_7"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74efd010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ebook_split_003.vue
// module id = 69
// module chunks = 0